"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _search = require("modals/search");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _temp;

var PeopleGroupResourcesTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PeopleGroupResourcesTab, _Component);

  function PeopleGroupResourcesTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PeopleGroupResourcesTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PeopleGroupResourcesTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "relatedSets", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PeopleGroupResourcesTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, this.relatedSets.map(function (set, index) {
        return _react.default.createElement("div", {
          className: "block stack catalog-group height-auto"
        }, set.title && _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement("h1", null, set.title)), _react.default.createElement("div", null, _react.default.createElement("div", {
          className: "card-container card-grid card-centered"
        }, set.items.map(function (card) {
          return _react.default.createElement(require(item.child_type).default, babelHelpers.objectSpread({
            key: card.id
          }, card));
        }))));
      }));
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      var _this2 = this;

      if (tab.visible()) {
        var order = tab.order,
            title = tab.title,
            id = tab.id;
        var r = {
          type: 'tab/PeopleGroupResources',
          relatedSets: []
        };

        if (object.lpShowAccessList != 'off') {
          r.relatedSets.push(this.getItemsFromAccessList(object, page, tab));
        }

        if (object.relatedRoot) {
          var items = new RecordList(_exports.default.Channel.tools.accountGroupRelated, _exports.default.Channel.tools.accountGroupRelated.lwp('find', {
            parent: object.relatedRoot,
            $order: 'parent_index',
            $orderDir: 'asc',
            child_type: 'node'
          }).records);
          r.relatedSets = r.relatedSets.concat(function (node) {
            return _this2.getItemsFromRelated(object, page, tab, node);
          });
        }

        r.relatedSets = r.relatedSets.filter(function (v) {
          return !!v;
        });

        if (r.relatedSets.length) {
          return babelHelpers.objectSpread({}, r, {
            order: order,
            title: title,
            id: id
          });
        }
      }

      return null;
    }
  }, {
    key: "getItemsFromRelated",
    value: function getItemsFromRelated(object, page, tab, relatedNode) {
      var rel = relatedNode.related[_exports.default.Channel.tools.catalog.toolID].record;

      if (rel.length) {
        rel = rel.filter(function (node) {
          return require('access-control/check-object-access').getObjectAccessInfo(node) !== false;
        });
      }

      if (rel.length) {
        var r = {
          title: relatedNode.headline || 'You may also like',
          items: rel.map(function (node) {
            return require("card/".concat(node.child_type)).default.card(node, page);
          }).filter(function (v) {
            return v;
          })
        };
        if (r.items.length) return r;
      }

      return null;
    }
  }, {
    key: "getContentItems",
    value: function getContentItems(treeRootId) {
      var _this3 = this;

      var processed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        records: {},
        groups: {}
      };
      var app = _exports.default.Channel.tools.accessItem;
      var children = new RecordList(app, app.lwp('find', {
        parent: treeRootId,
        $order: 'parent_index',
        $orderDir: 'asc'
      }).records);
      var contentNodes = [];
      children.forEach(function (node) {
        switch (node.child_type) {
          case 'contentItem':
            if (processed.records[node.itemId] || node.presentation == 'hidden' || node.grantAccess != '1') return;
            processed.records[node.itemId] = true;
            var item = _exports.default.Channel.tools.catalog.records[node.itemId];
            if (item) contentNodes.push({
              type: 'record',
              node: item
            });
            return;

          case 'contentGroup':
          case 'allContent':
            if (node.presentation == 'hidden' || node.grantAccess != '1') return;
            var contentNode = _exports.default.Channel.tools.catalog.groups[node.itemId];
            if (!contentNode) return;

            var all = _exports.default.Channel.tools.catalog._php_tool.tool_getRecordIDs(contentNode.id, false, false);

            if (node.groupFilter) all = _exports.default.Channel.tools.catalog.lwp('find', {
              id: all,
              child_type: node.groupFilter
            }).records;
            if (!all.length) return;

            switch (node.presentation) {
              case 'self':
                if (node.child_type == 'allContent') return;
                contentNodes.push({
                  type: 'group',
                  filterType: node.groupFilter,
                  node: contentNode
                });
                return;

              case 'contents':
                contentNode.groups.forEach(function (group) {
                  if (_exports.default.Channel.tools.catalog.lwp('find', babelHelpers.objectSpread({
                    id: _exports.default.Channel.tools.catalog._php_tool.tool_getRecordIDs(group.id, false, false)
                  }, node.groupFilter ? {
                    child_type: node.groupFilter
                  } : {})).records.length == 0) return;
                  if (contentNodes.filter(function (cnode) {
                    return cnode.type == 'group' && (!cnode.filterType || cnode.filterType == node.groupFilter) && cnode.node == group;
                  }).length) return;
                  contentNodes.push({
                    type: 'group',
                    filterType: node.groupFilter,
                    node: group
                  });
                });
                contentNode.records.forEach(function (record) {
                  if (processed.records[record.id]) return;
                  if (node.groupFilter && record.child_type != node.groupFilter) return;
                  processed.records[record.id] = true;
                  contentNodes.push({
                    type: 'record',
                    node: record
                  });
                });
                return;

              case 'records':
                var items = new RecordList(_exports.default.Channel.tools.catalog, all);
                items = items.sort(function (left, right) {
                  return left.title.toLowerCase() < right.title.toLowerCase() ? -1 : 1;
                });
                items.forEach(function (record) {
                  if (processed.records[record.id]) return;
                  processed.records[record.id] = true;
                  contentNodes.push({
                    type: 'record',
                    node: record
                  });
                });
                return;
            }

          case 'collection':
          case 'subscription':
            if (processed.records[node.itemId] || node.presentation == 'hidden' || node.grantAccess != '1') return;
            var contentNode = _exports.default.Channel.tools.catalog.records[node.itemId];
            if (!contentNode) return;

            switch (node.presentation) {
              case 'self':
                contentNodes.push({
                  type: 'record',
                  node: contentNode
                });
                processed.records[contentNode.id] = true;
                return;

              case 'contents':
                processed.records[contentNode.id] = true;
                contentNodes = contentNodes.concat(_this3.getContentItems(contentNode.itemRoot, processed));
                return;

              case 'records':
                var items = _this3.getContentItems(contentNode.itemRoot, processed);

                while (items.length) {
                  var item = item.shift();

                  if (item.type == 'record') {
                    if (item.node.child_type == 'collection' || item.node.child_type == 'subscription') items = _this3.getContentItems(item.node.itemRoot, processed).concat(items);else contentNodes.push(item);
                  } else {
                    var childItems = _exports.default.Channel.tools.catalog._php_tool.tool_getRecordIDs(item.node.id, false, false);

                    if (item.filterType) childItems = _exports.default.Channel.tools.catalog.lwp('find', {
                      id: childItems,
                      child_type: item.filterType
                    });
                    childItems.forEach(function (item) {
                      if (processed.records[item]) return;
                      var child = _exports.default.Channel.tools.catalog.records[item];
                      processed.records[item] = true;
                      if (child) contentNodes.push({
                        type: 'record',
                        node: child
                      });
                    });
                  }
                }

            }

        }
      });
      return contentNodes;
    }
  }, {
    key: "getItemsFromAccessList",
    value: function getItemsFromAccessList(object, page, tab) {
      var items = this.getContentItems(object.itemRoot);

      if (items.length) {
        var r = {
          title: 'You may also like',
          items: items.map(function (node) {
            return require("card/".concat(node.type == 'group' ? 'group' : node.node.child_type)).default.card(node.node, page);
          })
        };
        if (r.items.length) return r;
      }

      return null;
    }
  }]);
  return PeopleGroupResourcesTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "relatedSets", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = PeopleGroupResourcesTab;